import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TestRequest } from '../../models/TestRequest';
import { TestRequestService } from '../../services/test-request.service';
import 'rxjs/add/operator/toPromise';
import { saveAs } from 'file-saver';
import { ResponseContentType, RequestOptions, Http, Headers } from '@angular/http';


@Component({
  selector: 'app-request-details',
  templateUrl: './request-details.component.html',
  styleUrls: ['./request-details.component.css']
})
export class RequestDetailsComponent implements OnInit {

  Id: string;
  constructor(private activatedRoute: ActivatedRoute,
    private testRequestService: TestRequestService, private http: Http) {
  }
  testRequest: TestRequest = new TestRequest();
  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      this.Id = params['id'];
      this.testRequestService.getTestRequest(this.Id).subscribe(data => { this.testRequest = data });
    })
  }

  downloadRequestPdf() {

    let headers = new Headers();
   headers.append("Authorization", 'Bearer ' + JSON.parse(sessionStorage.getItem('token')).access_token);
    // headers.append("Content-Type", "application/json");
   headers.append("Accept", "application/octet-stream");

   const options = new RequestOptions({ responseType: ResponseContentType.Blob, headers: headers });
   this.http.get('api/testrequest/' + this.Id + '/pdf', options).toPromise()
      .then(response => this.saveToFileSystem(response));
  }

  private saveToFileSystem(response) {
    const contentDispositionHeader: string = response.headers.get('Content-Disposition');
    const parts: string[] = contentDispositionHeader.split(';');
    const filename = parts[1].split('=')[1].replace(' ','');
    //const filename = `${this.testRequest.HospitalNo}_${this.testRequest.Reference}_${this.testRequest.RequestDate.toLocaleDateString()}_requestForm.pdf`;
    const blob = new Blob([response._body], { type: 'text/plain' });
    saveAs(blob, filename);
  }
}
